import React from "react";
import ReactDOM from 'react-dom';

import Cart from "./cart/Cart";
import CartIcon from "./cart/CartIcon";
import ProductIndex from "./product-index/ProductIndex";
import InsectCalendar from "./insect-calendar/InsectCalendar";
import ProductPopup from "./product-popup/ProductPopup";
import StaffPopup from "./staff-popup/StaffPopup";
import ProblemSolver from "./problem-solver/ProblemSolver";

import ProductReview from "./product-review/ProductReview";

export default () => {

    const cartDoms = document.querySelectorAll('[data-cart]');
    let cartCheckout = false;
    for (const cartDom of cartDoms) {
        let fixed = false;
        if (cartDom.getAttribute('data-fixed')) {
            fixed = true;
        }
        if (cartDom.getAttribute('data-checkout')) {
            cartCheckout = true;
        }
        ReactDOM.render(<Cart fixed={fixed} cartCheckout={cartCheckout}/>, cartDom);
    }

    const cartIconDoms = document.querySelectorAll('[data-cart-icon]');
    for (const cartItemDom of cartIconDoms) {
        const link = cartItemDom.getAttribute('data-cart-link');
        ReactDOM.render(<CartIcon link={link} />, cartItemDom);
    }

    const productIndexDom = document.querySelector('[data-product-index]');
    if (productIndexDom) {
        const endpoint = productIndexDom.getAttribute('data-product-index');
        ReactDOM.render(<ProductIndex endpoint={endpoint} />, productIndexDom);
    }


    const insectCalendar = document.querySelector('[data-insect-page]');
    if (insectCalendar) {
        const url = insectCalendar.getAttribute('data-insect-page');
        ReactDOM.render(<InsectCalendar endpoint={url} />, insectCalendar);
    }


    const productPopup = document.querySelector('[data-product-popup]');
    if (productPopup) {
        ReactDOM.render(<ProductPopup />, productPopup);
    }

    const staffPopup = document.querySelector('[data-staff-popup]');
    if (staffPopup) {
        ReactDOM.render(<StaffPopup />, staffPopup);
    }

    const problemSolver = document.querySelector('[data-problem-solver]');
    if (problemSolver) {
        const url = problemSolver.getAttribute('data-problem-solver');
        const upload = problemSolver.getAttribute('data-upload');
        const submissions = problemSolver.getAttribute('data-submissions');
        ReactDOM.render(<ProblemSolver
            endpoint={url}
            upload={upload}
            submissions={submissions} />, problemSolver);
    }

    const productRates = document.querySelectorAll('[data-product-rate]');
    for (const rate of productRates){
        ReactDOM.render(<ProductReview
            readOnly={rate.getAttribute('data-readonly') == "1"}
            fieldId={rate.getAttribute('data-input')}
            value={parseInt(rate.getAttribute('data-value'))}
        />, rate);
    }


}
